import React, { useState, useEffect } from 'react';
import styles from './Loading.module.scss';
import PropTypes from 'prop-types';

const loadingList = [
  'Refueling jets',
  'Arming lasers',
  'Assigning colors',
  'Cleaning space',
  'Checking sattelites',
  'Warning aliens',
];

const Loading = ({ message }) => {
  const [loadingMessage, setLoadingMessage] = useState(loadingList[0]);

  useEffect(() => {
    const getRandomLoadingMessage = () => {
      return loadingList[Math.floor(Math.random() * loadingList.length)];
    };

    const loadCounter = setInterval(() => {
      let newLoadingMessage = loadingMessage;
      while (newLoadingMessage === loadingMessage) {
        newLoadingMessage = getRandomLoadingMessage();
      }
      setLoadingMessage(newLoadingMessage);
    }, 1500);
    return () => {
      clearInterval(loadCounter);
    };
  }, [loadingMessage]);

  return (
    <div className={styles.loading}>
      <div className={styles.loadingFlair}>
        {message ? message : loadingMessage}
      </div>
    </div>
  );
};

Loading.propTypes = {
  message: PropTypes.string,
};

Loading.defaultProps = {
  message: null,
};

export default Loading;
